import { documentBundleActions } from 'src/redux/actions/constant';

const {
  SUCCESS_GET_DOCUMENT_SUMMARY,
  FAILURE_GET_DOCUMENT_SUMMARY,
  LOADING_GET_DOCUMENT_SUMMARY,
  RESET_GET_DOCUMENT_SUMMARY,
} = documentBundleActions;

const initialState = {
  response: null as any,
  loading: false,
};

export const getDocumentSummaryReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case LOADING_GET_DOCUMENT_SUMMARY:
      return { ...state, loading: true };
    case SUCCESS_GET_DOCUMENT_SUMMARY:
      return { ...state, loading: false, response: action.payload };
    case FAILURE_GET_DOCUMENT_SUMMARY:
      return { ...state, loading: false, response: null };
    case RESET_GET_DOCUMENT_SUMMARY:
      return initialState;
    default:
      return state;
  }
};
